import { PERMISSIONS } from "@constants/user.roles";
import { STATIC_COURSE_ASSIGN_BROWSER_ROUTES } from "./browser.routes";
import { SPECIAL_INITIATIVE_ACCESS_PERMISSIONS } from "./permissions";

export const STATIC_COURSE_ASSIGN_PATH_PERMISSION_ENTRIES = [
	{
		pattern: STATIC_COURSE_ASSIGN_BROWSER_ROUTES.SPECIAL_INITIATIVE,
		permission: PERMISSIONS.COURSE_ASSIGNMENT_SPECIAL_INITIATIVE_READ,
		alternatePermissions: [...SPECIAL_INITIATIVE_ACCESS_PERMISSIONS],
	},
	{
		pattern: STATIC_COURSE_ASSIGN_BROWSER_ROUTES.COURSE_ASSIGN,
		permission: PERMISSIONS.COURSE_ASSIGNMENT_READ,
		alternatePermissions: [PERMISSIONS.COURSE_ASSIGNMENT_LIST],
	},
] as const;

export const STATIC_COURSE_ASSIGN_ORDERED_ROUTE_PERMISSIONS: [string, string][] = [
	[STATIC_COURSE_ASSIGN_BROWSER_ROUTES.SPECIAL_INITIATIVE, PERMISSIONS.COURSE_ASSIGNMENT_SPECIAL_INITIATIVE_READ],
	[STATIC_COURSE_ASSIGN_BROWSER_ROUTES.COURSE_ASSIGN, PERMISSIONS.COURSE_ASSIGNMENT_LIST],
];

export const STATIC_COURSE_ASSIGN_ROUTE_PERMISSIONS = [
	PERMISSIONS.COURSE_ASSIGNMENT_READ,
	PERMISSIONS.COURSE_ASSIGNMENT_LIST,
];

export function resolveStaticCourseAssignFirstAllowedRoute(
	path: string,
	userPermissions: string[],
	hasAllRead: boolean,
	permissionListIncludes: (permissions: string[], permission: string) => boolean,
): string | null {
	if (path === STATIC_COURSE_ASSIGN_BROWSER_ROUTES.SPECIAL_INITIATIVE) {
		if (
			hasAllRead ||
			SPECIAL_INITIATIVE_ACCESS_PERMISSIONS.some(p => permissionListIncludes(userPermissions, p))
		) {
			return path;
		}
	}

	if (path === STATIC_COURSE_ASSIGN_BROWSER_ROUTES.COURSE_ASSIGN) {
		if (hasAllRead || STATIC_COURSE_ASSIGN_ROUTE_PERMISSIONS.some(p => permissionListIncludes(userPermissions, p))) {
			return path;
		}
	}

	return null;
}
